import { Component } from '@angular/core';
import { AGENT_BUILDER_STEP_TITLE, ORGANIZATION_BUILDER_STEP_TITLE } from 'src/app/shared/constants/translations';
import { SharedStepperStep } from 'src/app/shared/shared-stepper/shared-stepper.component';

@Component({
  selector: 'app-agent-builder',
  templateUrl: './agent-builder.component.html',
  styleUrls: ['./agent-builder.component.scss'],
})
export class AgentBuilderComponent {
  steps: SharedStepperStep[] = [
    {
      label: 'personal',
      is_current: true,
      translation: AGENT_BUILDER_STEP_TITLE,
    },
    {
      label: 'organization',
      is_current: false,
      translation: ORGANIZATION_BUILDER_STEP_TITLE,
    },
  ];
}
